'use strict';

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

exports.eachAxis = eachAxis;
//# sourceMappingURL=each-axis.cjs.map
